module.exports = __webpack_public_path__ + "c67c993a917a4378c41d9665bfa227cd.png";